// extracted by mini-css-extract-plugin
module.exports = {"navigation":"style_navigation__3V1q7"};